import axios from 'axios'
import router from '../router'
import {getToken} from "../utils/auth";
import {ElMessage} from "element-plus";

const service = axios.create({
    // `url` 是用于请求的服务器 URL
    url: '',

    // `method` 是创建请求时使用的方法
    method: 'post', // default

    // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
    // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
    // baseURL: 'http://192.168.3.20:8888',
    // baseURL: 'http://47.111.16.233:8888',


//   Content-Type: application/json ： 请求体中的数据会以json字符串的形式发送到后端
//   Content-Type: application/x-www-form-urlencoded：请求体中的数据会以普通表单形式（键值对）发送到后端
//   Content-Type: multipart/form-data： 它会将请求体的数据处理为一条消息，以标签为单元，用分隔符分开。既可以上传键值对，也可以上传文件。
//   headers: {
//     // 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
//     'token':sessionStorage.getItem('token')
// },
    timeout: 60000,
// `withCredentials` 表示跨域请求时是否需要使用凭证
    withCredentials: false, // default
// proxy: {
//     host: 'http://192.168.3.20',
//     // host: 'http://47.111.16.233',

//     port: 8888,
//   },

})


//------------------- 一、请求拦截器 忽略
service.interceptors.request.use(function (config) {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
        config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
}, function (error) {
    console.log(error);
    // 对请求错误做些什么
    return Promise.reject(error);
});

//----------------- 二、响应拦截器 忽略
service.interceptors.response.use(function (response) {
    if (response.data) {
        if (response.data.code == -1 && response.data.msg != null) {
            ElMessage.warning(response.data.msg)
        }
    }
    return response.data;
}, function (error) {
    // 对响应错误做点什么
    console.log(error);
    if (error.response.status == 401) {//未登录
        // console.log("401")
        window.location.href = "https://zhpt.hbsis.gov.cn:9033/ZHPT_LOGIN_SERVER/login?service=https://zhpt.hbsis.gov.cn:6080/login-cas&utype=ent1";
        // router.push({path: '/',})
    } else if (error.response.status == 503) {//服务不可用
        alert('服务不可用(503)')
    } else if (error.response.status == 502 || error.response.status == 504) {//服务不可用
        alert('网络不可用')
    }

    return Promise.reject(error);
});
export default service
